import * as ChartType from "../../constants/ChartType"
import {createColumnsChart} from "./ColumnWithCategDrawer";
import {createPieChart} from "./PieChartDrawer";
import {createBasicAreaChart} from "./BasicAreaDrawer";
import {createColumnRangeChart} from "./ColumnRangeDrawer";
import {createColsWithCategsAndLabelsChart} from "./ColumnWithCategsAndLabelsDrawer";
import {createCombinationChart} from "./CombinationChartDrawer";
import {createGauge} from "./GaugeDrawer";
import {createHTMLDiv} from "./HTMLDrawer";
import {drawReport} from "./ReportInDashBoardDrawer";
import {createGridFlexTable} from "./TableAsGridDrawer";
import {drawCalendar, drawScheduler} from "./FullCalendarDrawer";
import {addHighChartsThemes, drawHighCharts} from "../highCharts/HighChartsDrawer";
import * as CommonConstants from "../../constants/CommonConstants";
import {ajaxJSON, areNotEqual, getFirstNotNullObj, registerOnWindowResize} from "../../common/NamaCommon";
import * as urls from "../../constants/NamaURLS";
import {createDefaultValues} from "../../routing/Presenters";
import * as cookies from "js-cookie";

import * as ChartsType from "../../constants/ChartsType";
import {QuestionFieldsEditor} from "../../widgets/QuestionFieldsEditor";
import {addIfNotFound} from "../../common/HasIDUtil";
import {createQuestionFromMapping} from "../edit/EmbeddedReportAndDashboardView";
import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";
import {isMobileDevice} from "../../common/GUIUtilities";
import {drawStackedAndGroupedColumn} from "./StackedAndGroupedDrawer";
import {handleDragEnd, handleDragEnter, handleDragLeave, handleDragOver, handleDragStart, handleDrop} from "./dragAndDrop";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

export let chartsResizeAttached = false;

export class ChartsDrawer {
    constructor(container, widgetId) {
        let that = this;
        that.questionFieldsEditor = new QuestionFieldsEditor();
        that.firstFetch = true;
        that.dashBoardId = "";
        that.parametersMapping = {};
        that.questions = [];
        that.dashBoardDiv = $(`  <section id="charts" class=" px-md-3">
        <div class="container-fluid">
            <div class="row">
            </div>
        </div>
    </section>`);
        that.root = container;
        that.container = that.dashBoardDiv.find(".row");
        that.widgetId = widgetId;
        that.widgetTimeout = new Map();
    }

    fetchCharts(dashBoardId) {
        let that = this;
        if (areNotEqual(dashBoardId, that.dashBoardId) || !that.metadata)
            that.fetchMetadata(dashBoardId);
        else
            that.drawCharts("", false, false);
        that.dashBoardId = dashBoardId;
        that.attachWindowResize();
    }

    attachWindowResize() {
        let that = this;
        that.dashBoardDiv.height(that.calcOffsetHeight());
        if (chartsResizeAttached)
            return;
        chartsResizeAttached = true;
        registerOnWindowResize(window[0], (e) => {
                that.dashBoardDiv.height(that.calcOffsetHeight());
                let charts = that.container.find(".chartContainer");
                for (let chart of charts) {
                    let heightPercent = $(chart).attr("heightPercent");
                    let widthPercent = $(chart).attr("widthPercent");
                    let rowNumber = $(chart).attr("rowNumber");
                    let totalRowsCount = $(chart).attr("totalRowsCount");
                    let windowHeight = that.dashBoardDiv.height();
                    let windowWidth = $(window).width();
                    let chartHeight = windowHeight * heightPercent;
                    let chartWidth = windowWidth * widthPercent;
                    $(chart).height(chartHeight);
                    $(chart).width(chartWidth);
                    let widgetTop = that.calcWidgetTop(rowNumber, totalRowsCount);
                    $(chart).css("top", widgetTop);
                    let chartDiv = $(chart).find(".chartDiv");
                    let highChart = $(chartDiv).attr("highChart");
                    if (highChart == "true") {
                        let ch = chartDiv.highcharts();
                        if (ch) {
                            ch.setSize(chartWidth, chartHeight - 75);
                            ch.reflow();
                        }
                    } else {
                        let chartData = chartDiv.data("kendoChart");
                        if (chartData) {
                            let options = $.extend({}, chartData.options);
                            options.chartArea = {
                                margin: 5,
                                width: chartWidth,
                                height: chartHeight - 75
                            };
                            chartData.setOptions(options);
                            chartData.resize();
                        }
                    }
                }
            }
        );
    }

    fetchMetadata(dashboardId) {
        let that = this;
        ajaxJSON(urls.FetchChartsMetadata, {
                dashBoardId: dashboardId
            }, (result) => {
                that.doSetMetadata(result);
            }
        );
    }

    doSetMetadata(fetchedMetadata) {
        let that = this;
        that.metadata = {
            metadata: [],
            questionFields: [],
            allParameterIds: []
        };
        if (fetchedMetadata.list && fetchedMetadata.list.length) {
            for (let subMetadata of fetchedMetadata.list) {
                that.merge(that.metadata, subMetadata);
            }
        }
        if (!that.metadata.questionFields || that.allQuestionsAreHidden())
            that.drawCharts("", false, false);
        else
            that.showQuestionsPopupPanel();
    }

    showQuestionsPopupPanel() {
        let that = this;
        let questionsFromMapping = createQuestionFromMapping(that.parametersMapping);
        let defaultValues = createDefaultValues(that.metadata);
        if (!that.firstFetch)
            defaultValues = that.questionFieldsEditor.getQuestionFields();
        addIfNotFound(questionsFromMapping, defaultValues);
        let hiddenQuestions = null;
        if (!that.parametersMapping)
            hiddenQuestions = that.parametersMapping.hiddenParameters;
        let window = new NamaKendoWindow("parameters", new NamaWindowBtnData("ok", () => {
            if (that.questionFieldsEditor.getNotFilledRequiredFields().length)
                return;
            if (that.firstFetch)
                that.drawCharts("", false, false);
            else
                that.drawCharts("", true, false);
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"));
        that.questionFieldsEditor.edit(that.metadata.questionFields, questionsFromMapping, hiddenQuestions, null, null, window);
        window.showWindow(null, true);
    }

    allQuestionsAreHidden() {
        let that = this;
        return that.parametersMapping && (that.parametersMapping.hiddenParameters || []).length == that.metadata.questionFields.length;
    }

    merge(metadata, subMetadata) {
        addIfNotFound(metadata.metadata, subMetadata.metadata);
        addIfNotFound(metadata.questionFields, subMetadata.questionFields);
        for (let param of subMetadata.allParameterIds) {
            if (!metadata.allParameterIds.contains(param))
                metadata.allParameterIds.push(param);
        }
    }


    drawCharts(widgetId, fromDashBoardRefresh, fromWidgetRefresh) {
        let that = this;
        ajaxJSON(urls.FetchCharts, {
                dashBoardId: that.dashBoardId,
                widgetId: widgetId,
                questions: JSON.stringify(that.questionFieldsEditor.getQuestionFields())
            }, (result) => {
                that.drawDashBoard(result.data, fromDashBoardRefresh, fromWidgetRefresh);
            }
        );
    }

    /**
     *
     * @param {namaTypes.DTOUserDashboardResponse} chartsData
     * @param container
     */
    async drawDashBoard(chartsData, fromDashBoardRefresh, fromWidgetRefresh) {
        let chartsType = getFirstNotNullObj(localStorage.getItem("chartsType"), cookies.get("chartsType"));
        let highCharts = !chartsType || chartsType === ChartsType.HighCharts;
        let charts = chartsData.chartLines;
        if (!charts)
            return;
        let that = this;
        let container = that.container;
        that.firstFetch = false;
        if (!fromWidgetRefresh)
            container.html("");
        if (charts && charts.length && !fromWidgetRefresh)
            addHighChartsThemes(chartsData, that.root, highCharts, that);
        let offsetHeight = that.dashBoardDiv.height();
        let width = window.innerWidth;
        if (that.embeddedChartsWidth)
            width = that.embeddedChartsWidth;
        let maxColNum = Math.max(...charts.map(o => o.colNumber));
        let offsetWidth = width - (maxColNum * 5);
        let totalColsCount = chartsData.colsCount;
        let totalRowsCount = chartsData.rowsCount;
        let oneColWidth = (offsetWidth / totalColsCount);

        /**
         * @type namaTypes.DTOUserDashbordChartLine
         */
        that.root.append(that.dashBoardDiv);
        for (let line of charts) {
            let height = (line.rows / totalRowsCount) * (offsetHeight);
            let width = (line.cols / totalColsCount) * offsetWidth;
            if (!highCharts && width)
                width = width + "px";
            if (isMobileDevice()) {
                width = "100%";
            }
            let colNumber = line.colNumber;
            let rowNumber = line.rowNumber;
            let widgetTop = that.calcWidgetTop(rowNumber, totalRowsCount);
            let widgetLeft = ((colNumber - 1) * oneColWidth);
            let widgetDivId = line.widgetId + CommonConstants.SEPARATOR + colNumber + "" + rowNumber;
            let widgetDiv = container.find("#" + widgetDivId);
            if (!widgetDiv.length) {
                widgetDiv = $(`<div id = ${widgetDivId} class ="chartContainer" style="position: absolute; top: ${widgetTop}px; left: ${widgetLeft}px; padding-left: 2px; padding-right: 2px">
                        <div class="container-drag">
                            <div draggable="true" class="box">
                                <div class="icons p-3 chartHeaderTitle">
                                ${calcChartTitle(line)}
                                </div>
                                <figure class="highcharts-figure border">
                                </figure>
                            </div>
                        </div>
                    </div>`);
                widgetDiv.width(width);
                widgetDiv.height(height);
                container.append(widgetDiv);
            }
            height = height - 75;
            let widgetId = line.widgetId + CommonConstants.SEPARATOR + widgetTop;
            let widget = widgetDiv.find("#" + widgetId);
            if (!widget.length) {
                widget = $(`<div class ="chartDiv" id = ${widgetId}></div>`);
                widget.attr("namaChartId", line.widgetId);
                widget.attr("highChart", highCharts);
                widgetDiv.find(".highcharts-figure").append(widget);
            }
            if (highCharts)
                await drawHighCharts(line, height, width, widget);
            else
                await that.drawWidget(line, height, width, widget);
            if (isMobileDevice() && widget.data("kendoChart") && that.widgetsWithLargeLabels(line.chartType)) {
                widget.data("kendoChart").options.series[0].padding = 120;
                widget.data("kendoChart").redraw();
            }
            that.attachWidgetRefreshEvent(line, fromDashBoardRefresh, container);
            widgetDiv.find(".highcharts-title").remove();
            let chartHeightPercent = widgetDiv.height() / that.dashBoardDiv.height();
            let chartWidthPercent = widgetDiv.width() / $(window).width();
            widgetDiv.attr("heightPercent", chartHeightPercent);
            widgetDiv.attr("widthPercent", chartWidthPercent);
            widgetDiv.attr("rowNumber", rowNumber);
            widgetDiv.attr("totalRowsCount", totalRowsCount);
        }
        that.attachDashboardRefreshEvent(chartsData, fromWidgetRefresh, container);
        that.attachDragAndDropEvents();
        that.dashBoardDiv.height(that.calcOffsetHeight());
    }

    calcOffsetHeight() {
        let that = this;
        let navBarHeight = $(".navbar").outerHeight();
        let quickIconsHeight = $(".quick-icons").outerHeight();
        let height = window.innerHeight;
        if (that.embeddedChartsHeight)
            height = that.embeddedChartsHeight;
        let offsetHeight = height - navBarHeight - quickIconsHeight - 25;
        return offsetHeight;
    }

    calcWidgetTop(rowNumber, totalRowsCount) {
        let that = this;
        let oneRowHeight = that.dashBoardDiv.height() / totalRowsCount;
        return ((rowNumber - 1) * oneRowHeight);
    }

    attachDragAndDropEvents() {
        let items = document.querySelectorAll('.container-drag .box');
        items.forEach(function (item) {
            item.addEventListener('dragstart', handleDragStart, false);
            item.addEventListener('dragenter', handleDragEnter, false);
            item.addEventListener('dragover', handleDragOver, false);
            item.addEventListener('dragleave', handleDragLeave, false);
            item.addEventListener('drop', handleDrop, false);
            item.addEventListener('dragend', handleDragEnd, false);
        });
    }

    widgetsWithLargeLabels(chartType) {
        return (chartType === ChartType.ColumnWithRotatedLabels || chartType === ChartType.PieChart || chartType === ChartType.ThreeDPieChart || chartType === ChartType.CombinationChart)
    }

    /**
     *
     * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
     * @param {string} h
     * @param {string} w
     * @return {*}
     */
    drawWidget(userDashboardChartLine, h, w, widget) {
        let chartArea = {
            margin: 5,
            width: w,
            height: h
        };
        if (isMobileDevice())
            chartArea = {
                margin: 5,
            };
        let chartType = userDashboardChartLine.chartType;
        switch (chartType) {
            case ChartType.PieChart:
                return createPieChart(userDashboardChartLine, h, w, false, widget, chartArea);
            case ChartType.ThreeDPieChart:
                return createPieChart(userDashboardChartLine, h, w, true, widget, chartArea);
            case ChartType.ColumnWithRotatedLabels:
                return createColumnsChart(userDashboardChartLine, h, w, widget, chartArea);
            case ChartType.ColumnWithCategsAndLabels:
                return createColsWithCategsAndLabelsChart(userDashboardChartLine, h, w, widget, chartArea);
            case ChartType.CombinationChart:
                return createCombinationChart(userDashboardChartLine, h, w, widget, chartArea);
            case ChartType.Table:
                return createGridFlexTable(userDashboardChartLine, h, w, widget);
            case ChartType.BasicAreaChart:
                return createBasicAreaChart(userDashboardChartLine, h, w, widget, chartArea);
            case ChartType.Gauge:
                return createGauge(userDashboardChartLine, h, w, widget);
            case ChartType.HTML:
                return createHTMLDiv(userDashboardChartLine, h, w, widget);
            case ChartType.ColumnRange:
                return createColumnRangeChart(userDashboardChartLine, h, w, widget, chartArea);
            case ChartType.Calendar:
                return drawCalendar(userDashboardChartLine, h, w, widget);
            case ChartType.ResourceView:
                return drawScheduler(userDashboardChartLine, h, w, widget);
            case ChartType.Report:
                return drawReport(userDashboardChartLine, h, w, widget);
            case ChartType.StackedAndGroupedColumn:
                return drawStackedAndGroupedColumn(userDashboardChartLine, h, w, widget, chartArea);
            default:
                break;
        }
    }

    attachDashboardRefreshEvent(chartsData, fromWidgetRefresh) {
        let that = this;
        if (fromWidgetRefresh === true)
            return;
        let refreshAfter = chartsData.refreshPer;
        if (!refreshAfter || refreshAfter === 0)
            return;
        that.dashBoardTimeout = setTimeout(() => {
            that.drawCharts("", true, false);
        }, refreshAfter);
    }

    attachWidgetRefreshEvent(userDashboardChartLine, fromDashBoardRefresh) {
        let that = this;
        if (fromDashBoardRefresh === true)
            return;
        let refreshAfter = userDashboardChartLine.refreshPer;
        if (!refreshAfter || refreshAfter === 0)
            return;
        let widgetId = userDashboardChartLine.widgetId;
        that.widgetTimeout.set(widgetId, setTimeout(() => {
            that.drawCharts(widgetId, false, true);
        }, refreshAfter));
    }
}